import { api } from "../../api";
import { PLAYLIST_ENDPOINTS } from "../../../constants/endpoints";

export const playlistApi = api.injectEndpoints({
  endpoints: (builder) => ({
    playlistInit: builder.mutation({
      query: (payload) => ({
        url: PLAYLIST_ENDPOINTS.INIT,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
    }),
    getPlaylistById: builder.query({
      query: (payload) => ({
        url: PLAYLIST_ENDPOINTS.GET_BY_ID, // 👈 devi aggiungerlo nei tuoi endpoint
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
      providesTags: (result, error, arg) => {
        const rawId =
          result?.data?.result?.id || (arg && "id" in arg ? arg.id : undefined);
        const id = rawId != null ? String(rawId) : null;
        return id
          ? [
              { type: "Playlist", id },
              { type: "Playlist", id: "LIST" },
            ]
          : [{ type: "Playlist", id: "LIST" }];
      },
    }),
    getAllPlaylists: builder.query({
      query: (payload) => ({
        url: PLAYLIST_ENDPOINTS.GET_ALL,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
      providesTags: [{ type: "Playlist", id: "LIST" }],
    }),
    createPlaylist: builder.mutation({
      query: (payload) => ({
        url: PLAYLIST_ENDPOINTS.CREATE,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
      invalidatesTags: [{ type: "Playlist", id: "LIST" }],
    }),
    updatePlaylist: builder.mutation({
      query: (payload) => ({
        url: PLAYLIST_ENDPOINTS.UPSERT,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
      invalidatesTags: (result, error, arg) => {
        const rawId = arg?.id ?? result?.data?.result?.id;
        const id = rawId != null ? String(rawId) : null;
        return id
          ? [
              { type: "Playlist", id },
              { type: "Playlist", id: "LIST" },
            ]
          : [{ type: "Playlist", id: "LIST" }];
      },
    }),
    updatePlaylistIsHome: builder.mutation({
      query: ({ id,isHome }) => ({
        url: PLAYLIST_ENDPOINTS.UPDATE_IS_HOME,
        method: "POST",
        body: new URLSearchParams({ id,isHome }).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
      invalidatesTags: (result, error, arg) => {
        const id = arg?.id != null ? String(arg.id) : null;
        return id
          ? [
              { type: "Playlist", id },
              { type: "Playlist", id: "LIST" },
            ]
          : [{ type: "Playlist", id: "LIST" }];
      },
    }),
    deletePlaylist: builder.mutation({
      query: (payload) => ({
        url: PLAYLIST_ENDPOINTS.DELETE,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
      invalidatesTags: (result, error, arg) => {
        const id = arg?.id != null ? String(arg.id) : null;
        return id
          ? [
              { type: "Playlist", id },
              { type: "Playlist", id: "LIST" },
            ]
          : [{ type: "Playlist", id: "LIST" }];
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  usePlaylistInitMutation,
  useGetAllPlaylistsQuery,
  useCreatePlaylistMutation,
  useUpdatePlaylistMutation,
  useDeletePlaylistMutation,
  useGetPlaylistByIdQuery,
  useUpdatePlaylistIsHomeMutation
} = playlistApi;
